import { Injectable } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { BehaviorSubject, Subject, combineLatest, distinctUntilChanged, filter, map, of, startWith, switchMap, takeUntil } from 'rxjs';
import { ProcessStepperService } from '../../process-stepper.service';
import { SignProcessWizardService } from '../../sign-process-wizard.service';


@Injectable()
export class SelectActivitiesStepService {

  private readonly _destroy = new Subject<void>();

  readonly activitiesFormArraySubject = new BehaviorSubject(new FormArray<any>([]))
  get activitiesFormArray() {
    return this.activitiesFormArraySubject.value;
  }

  readonly activitiesSubject = this._signProcessWizardService.activitiesSubject;
  readonly watchersSubject = this._signProcessWizardService.watchersSubject;

  readonly stepValidObs = this.activitiesFormArraySubject.pipe(
    switchMap((activitiesFormArray) => {
      if (!activitiesFormArray.length) {
        return of(false);
      }

      return activitiesFormArray.statusChanges.pipe()
        .pipe(
          startWith(activitiesFormArray.status),
          map((status) => status === 'VALID'),
          distinctUntilChanged()
        )
    })
  )

  readonly triedNextObs = this._processStepperService.triedNextSubject
    .pipe(
      map((triedNext) => Boolean(triedNext.selectSigners)),
      distinctUntilChanged(),
    )


  readonly showNoActivitesErrorObs = combineLatest([this.triedNextObs, this.activitiesFormArraySubject])
    .pipe(
      map(([triedNext, activitiesFormArray]) => triedNext && activitiesFormArray.length === 0)
    )


  constructor(
    private _signProcessWizardService: SignProcessWizardService,
    private _processStepperService: ProcessStepperService
  ) {

    this.activitiesFormArraySubject.pipe(
      filter(Boolean),
      takeUntil(this._destroy)
    )
      .subscribe((activitiesFormArray) => {
        activitiesFormArray.updateValueAndValidity();
      })
  }


  addForm(form: FormGroup) {
    this.activitiesFormArray.controls.push(form);

    form.statusChanges.pipe(
      takeUntil(this._destroy),
      startWith(form.status),
      distinctUntilChanged()
    )
      .subscribe(() => {
        this.activitiesFormArray.updateValueAndValidity();
      })

    this.activitiesFormArraySubject.next(this.activitiesFormArray);
  }


  removeForm(form: FormGroup) {

    const idx = this.activitiesFormArray.controls.indexOf(form);

    if (idx < 0) {
      return;
    }

    this.activitiesFormArray.controls.splice(idx, 1);

    this.activitiesFormArraySubject.next(this.activitiesFormArray);

  }


  ngOnDestroy() {

    this._destroy.next();
    this._destroy.complete();

  }


}


